import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropFieldSelectShow = ({ property }) => {
  const { publicLabel, value, minValue, options, label } = property;

  const selectedOptions = options.filter(
    (obj) => value?.includes(obj.value) || minValue?.includes(obj.value)
  );

  const showString =
    selectedOptions.length > 0
      ? selectedOptions.reduce((acc, el, index) => {
          return (acc += index == 0 ? el.label : ', ' + el?.label);
        }, '')
      : '-';

  return (
    <Box className="flex items-start justify-start gap-2">
      <Typography fontWeight={600}>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${showString || '-'}`}</Typography>
    </Box>
  );
};
